import {KIOSK_APP_SETTINGS_DATA} from "../../constants/ActionTypes";

const INIT_STATE = {
    appSettings: [],
};

const kioskAppSettingsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case KIOSK_APP_SETTINGS_DATA: {
            return {
                ...state,
                appSettings: action.payload,
            }
        }
        default:
            return state;
    }
}

export default kioskAppSettingsReducer;
